import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Workflow } from 'app/Model/Dto/Workflow/Workflow';

type DevExtremeValueChangedEvent = { value?: unknown };

@Component({
  selector: 'app-dataprocess-workflowplan',
  templateUrl: './dataprocess-workflowplan.component.html',
  styleUrl: './dataprocess-workflowplan.component.css'
})
export class DataprocessWorkflowplanComponent {
  @Input() public workflows: Workflow[] = [];
  @Input() public selectedWorkflowId: string;
  @Input() public isReadOnly: boolean = false;

  @Output() public selectedWorkflowIdChanged = new EventEmitter<string | null>();
  @Output() public createWorkflowRequested = new EventEmitter<void>();
  @Output() public duplicateWorkflowRequested = new EventEmitter<void>();
  @Output() public addWorkflowItemRequested = new EventEmitter<void>();
  @Output() public deleteWorkflowRequested = new EventEmitter<void>();
  @Output() public editWorkflowRequested = new EventEmitter<void>();

  public onWorkflowSelectionChanged(event: DevExtremeValueChangedEvent): void {
    const selectedWorkflowId = event?.value as string;
    this.selectedWorkflowIdChanged.emit(selectedWorkflowId);
  }

  public requestCreateWorkflow(): void {
    this.createWorkflowRequested.emit();
  }

  public requestDuplicateWorkflow(): void {
    this.duplicateWorkflowRequested.emit();
  }

  public requestAddWorkflowItem(): void {
    this.addWorkflowItemRequested.emit();
  }

  public requestDeleteWorkflow(): void {
    this.deleteWorkflowRequested.emit();
  }

  public requestEditWorkflow(): void {
    this.editWorkflowRequested.emit();
  }
}
